import * as actionTypes from "./types";

export const toggleFavorite = (menuItemId) => ({
  type: actionTypes.TOGGLE_FAVORITE,
  payload: menuItemId,
});

export const selectIsFavorite = (state, menuItemId) =>
  !!state.userData.favorites[menuItemId];
